import React from 'react';
import './error.css'

const ErrorIndicator = () => {
    return <div className='error'>
        Что-то пошло не так!
        Попробуйте перезагрузить страницу
    </div>
}

export default ErrorIndicator;